import styled from "styled-components";
import {Link} from "react-router-dom";

export const Button = styled.button`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  color: white;
  background-color: var(--bs-primary);
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  column-gap: 8px;
  transition: all ease 300ms;

  i {
    font-size: 1.25rem;
  }

  &:hover {
    background-color: #120E35;
  }
`

export const OutlineButton = styled.button`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  column-gap: 8px;
  transition: all ease 300ms;
  color: black;

  i {
    font-size: 1.25rem;
  }

  &:hover {
    color: white;
    background-color: var(--bs-primary);
  }
`

export const OutlineButtonLink = styled(Link)`
    font-size: 1.125rem;
    font-weight: bold;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    cursor: pointer;
    background-color: transparent;
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    column-gap: 8px;
    transition: all ease 300ms;

    i {
        font-size: 1.25rem;
    }

    &:hover {
        color: white;
        background-color: var(--bs-primary);
    }
`
